/** @jsx jsx */
import { useState, Fragment, useEffect } from 'react'
import { jsx, Container, Flex, Box } from 'theme-ui'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { Image } from '../../Components/Images'
import { SystemStyleObject } from '@styled-system/css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'

const Header = () => {
  function formatPhoneNumber(phone: string) {
    var cleaned = ('' + phone).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      let intlCode = match[1] ? '1-' : ''
      return [intlCode, '', match[2], '-', match[3], '-', match[4]].join('')
    }
    return null
  }

  const data = useStaticQuery(
    graphql`
      query {
        logo: file(relativePath: { eq: "logos/logo.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `
  )
  return (
    <header
      sx={{
        bg: `#fff`,
        marginBottom: `1.45rem`,
        position: 'fixed',
        top: '0',
        zIndex: '1000',
        display: 'block',
        width: '100%',
      }}
    >
      <div
        sx={{
          boxShadow: '0 0 3px #666',
          position: 'relative',
        }}
      >
        <Container sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
          <Flex
            as="nav"
            style={{
              margin: `0 auto`,
              maxWidth: 960,
              padding: '10px',
              position: 'relative',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Link
                to="/"
                style={{
                  color: `white`,
                  textDecoration: `none`,
                }}
              >
                <Image
                  sx={
                    {
                      width: ['200px', '235px'],
                      img: {
                        objectFit: 'contain !important',
                      },
                    } as SystemStyleObject
                  }
                  fluid={data.logo.childImageSharp.fluid}
                />
              </Link>
            </Box>
            <Box>
              <div
                sx={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  top: '3px',
                }}
              >
                <div
                  sx={{
                    display: 'flex',
                    marginRight: '10px',
                    alignItems: 'end',
                  }}
                >
                  <div
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bg: '#F59E21',
                      borderRadius: '50%',
                      mr: '5px',
                      position: 'relative',
                      top: '-3px',
                      width: '35px',
                      height: '35px',
                    }}
                  >
                    <FontAwesomeIcon
                      icon={'phone-alt'}
                      sx={{
                        color: '#fff',
                        position: 'relative',
                        width: '16px',
                        height: '16px',
                      }}
                    />
                  </div>
                  <a
                    href={`tel:1-888-970-2846`}
                    sx={{
                      display: ['none', null, 'inherit'],
                      fontFamily: 'nimbus-sans, sans-serif',
                      fontWeight: '400',
                      textDecoration: 'none',
                      color: '#1E988A',
                      fontSize: '24px',
                      letterSpacing: '0px',
                    }}
                  >
                    {formatPhoneNumber('1-888-970-2846')}
                  </a>
                </div>
              </div>
            </Box>
          </Flex>
        </Container>
      </div>
    </header>
  )
}
export default Header
